export default __webpack_public_path__ + "static/va-loan-expert-07186fd5beeb19fd50686c32a0e986af.png";